import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  container: {
    backgroundColor: palette.background.default,
    boxShadow: 'none',
    minHeight: 92
  },
  cardContent: {
    padding: spacing(1),
    '&:last-child': {
      paddingBottom: spacing(1),
    },
  },
  icon: {
    display: 'block'
  }
}));
